uvex-search {
  uvex-search-box {
    margin-bottom: 1rem;
  }

  .container-search-box {
    max-width: 940px;
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .search-results-container {
    padding: 2rem 0 4rem 0;
  }

  .search-result-item {
    background: #fff;
    padding: 1rem;
  }

  .search-result-content :last-child {
    margin-bottom: 0;
  }

  .search-results-number {
    margin-bottom: 0;
  }
}
